<div class="complete-profile-banner" (click)="click.emit()">
    <ng-content></ng-content>
</div>
